import React, { useCallback, useState } from "react";
import { HiOutlineClipboardCopy, HiOutlineRefresh } from "react-icons/hi";
import { classNames } from "Utils/utils";

const MessageActions = ({
  content,
  onRegenerate,
  showRegenerate = false,
  className = "",
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(String(content || ""));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // Clipboard unavailable — silent fail.
    }
  }, [content]);

  return (
    <div className={classNames("flex items-center gap-0.5", className)}>
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium text-slate-500 transition-colors hover:bg-slate-100 hover:text-[#4B6CB7]"
        aria-label="Copy response"
      >
        <HiOutlineClipboardCopy className="h-3.5 w-3.5" />
        {copied ? "Copied" : "Copy"}
      </button>
      {showRegenerate && onRegenerate ? (
        <button
          type="button"
          onClick={onRegenerate}
          className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-medium text-slate-500 transition-colors hover:bg-slate-100 hover:text-[#4B6CB7]"
          aria-label="Regenerate response"
        >
          <HiOutlineRefresh className="h-3.5 w-3.5" />
          Regenerate
        </button>
      ) : null}
    </div>
  );
};

export default MessageActions;
